module.exports = __webpack_public_path__ + "assets/img/7.ff6e2c0c.png";